module.exports = __webpack_public_path__ + "static/media/CABA.c0ee4976.svg";